import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React, { FC } from 'react'

import { FormattedPrice } from '@src/blocks/currency'
import { festivalOfferPriceForCard } from '@src/quince-site-common/src/utils/festivalOffersUtility'

import { ProductTitleSectionProps } from './product-title-section'
import styles from './product-title-section.module.scss'

type ProductPriceProps = {
  isNotAttachedToProductTitleSection?: boolean
} & ProductTitleSectionProps

export const ProductPrice: FC<ProductPriceProps> = props => {
  const {
    selectedCardVariant,
    productPrefixPriceClassName,
    priceClassName,
    productPriceClass,
    isNotAttachedToProductTitleSection,
  } = props
  const { t } = useTranslation('common')
  const salePrice = selectedCardVariant?.price?.salePrice
  const showFrom = selectedCardVariant?.price?.isRange

  const festivalPrice = selectedCardVariant ? festivalOfferPriceForCard(selectedCardVariant) : null

  return (
    <div className={styles.nameAndPriceSection}>
      {isNotAttachedToProductTitleSection ? (
        <div className={classnames(styles.notAttachedToProductTitleSectionProductPriceWrapper, productPriceClass)}>
          <div className={classnames(styles.festivalOfferText)}>
            {showFrom && (
              <div className={classnames(styles.productPrefixPrice, productPrefixPriceClassName)}>{t('from')}</div>
            )}
            <div
              className={classnames(priceClassName, {
                [`${styles.basePrice}`]: festivalPrice,
              })}
            >
              <FormattedPrice amount={salePrice} />
            </div>
          </div>
          {festivalPrice && (
            <div className={classnames(props.priceClassName, styles.festivalPrice)}>
              <FormattedPrice amount={festivalPrice} />
            </div>
          )}
        </div>
      ) : (
        <div
          className={classnames(styles.productPriceWrapper, productPriceClass, {
            [`${styles.festivalOfferWrapper}`]: festivalPrice,
          })}
        >
          <div className={classnames(styles.festivalOfferText)}>
            {showFrom && (
              <div className={classnames(styles.productPrefixPrice, productPrefixPriceClassName)}>{t('from')}</div>
            )}
            {festivalPrice && (
              <div className={classnames(props.priceClassName, styles.festivalPrice)}>
                <FormattedPrice amount={festivalPrice} />
              </div>
            )}
          </div>
          <div className={classnames(priceClassName, styles.basePrice)}>
            <FormattedPrice amount={salePrice} />
          </div>
        </div>
      )}
    </div>
  )
}
